import React from 'react';

import PropTypes from 'prop-types';
import { Pagination, Table } from 'semantic-ui-react';

const propTypes = {
  onPageChange: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
};

function OrderReportsTableFooter({ onPageChange, currentPage, totalPages }) {
  return (
    <Table.Footer>
      <Table.Row>
        <Table.HeaderCell colSpan="7">
          <Pagination
            onPageChange={onPageChange}
            activePage={currentPage}
            totalPages={totalPages}
          />
        </Table.HeaderCell>
      </Table.Row>
    </Table.Footer>
  );
}

OrderReportsTableFooter.propTypes = propTypes;

export default OrderReportsTableFooter;
